import { precompileTemplate } from "@ember/template-compilation";
export default precompileTemplate("<EventNotFound />\n", {
  moduleName: "ilios-common/templates/event-not-found.hbs"
});